export { default as MarkdownHighlightExtension } from './MarkdownHighlightExtension';
